export enum OTP_EVENT_TYPE {
  USER_LOGIN = 'user-login',
  FIRST_TIME_LOGIN = 'first-time-login',
  FORGOT_PASSWORD = 'forgot-password',
  FORGOT_PIN = 'reset-pin',
  CHANGE_PASSWORD = 'change-password',
}
